export default __webpack_public_path__ + "static/media/week.9cade9e7.svg";